/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Load_Note_FailedInputs */

const vi_sinp_load_note_failed = /** @type {(inputs: Sinp_Load_Note_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được chi tiết phiếu nhập kho để in. Kiểm tra kết nối mạng rồi bấm in lại.`)
};

/**

* @param {Sinp_Load_Note_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_load_note_failed = /** @type {((inputs?: Sinp_Load_Note_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Load_Note_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_load_note_failed(inputs)
});